// extracted by mini-css-extract-plugin
export default {"maxWidthInPc":"450px","container":"style_container__OD6dZ"};